//TO MUSI BYĆ ABY BUNDLE ZAWIERAŁ KLASY Z components
//TS nie kompiluje nieużywanych klas??
import "udce-engine";
import "app"
import { DceEngine } from "udce-engine";

DceEngine.start('data-dce');
